import React from "react";
import { Tag } from "antd";

export const newApps = (leng) => {
  return [
    {
      title: () => (
        <>
          App Name <Tag color="processing">{leng}</Tag>
        </>
      ),
      dataIndex: "app_name",
      key: "app_name",
      fixed: "left",
      sorter: (a, b) => (a.app_name ? a.app_name.localeCompare(b.app_name) : 1),
      width: "30%",
    },
    {
      title: "Domains",
      dataIndex: "domains",
      key: "domains",
      fixed: "left",
      width: "30%",
      ellipsis: true,
    },
    {
      title: "Old Category",
      dataIndex: "old_category",
      key: "old_category",
      fixed: "left",
      sorter: (a, b) =>
        a.old_category ? a.old_category.localeCompare(b.old_category) : 1,
      width: "20%",
    },
    {
      title: "New Category",
      dataIndex: "current_category",
      key: "current_category",
      fixed: "left",
      sorter: (a, b) =>
        a.current_category
          ? a.current_category.localeCompare(b.current_category)
          : 1,
      width: "20%",
    },
  ];
};


export const tabPageCss = {
  padding: "0",
  marginBottom: "0",
};

export const cardCss = { padding: "0", borderStyle: "hidden" };
